import { BindingEdit } from "../../../../../lib/comps/PropPanel/PropPanel/ParamItem/BindingEdit";
import { getRelatedPropsOfBinding } from "../../../../../lib/utils/bindings";
import { InteropableInput, JsExpr } from "../../../../../lib/comps/PropPanel/PropPanel/ParamItem/ParamItemInputModes";
import { isExprObject } from '@tencent/data-schema-core/lib/utils/eval';
const hasBinding = vm => {
  try {
    var _vm$paramContext$comp, _vm$paramContext$comp2;
    const bindingMeta = (_vm$paramContext$comp = vm.paramContext.compMeta) === null || _vm$paramContext$comp === void 0 || (_vm$paramContext$comp = _vm$paramContext$comp.bindings) === null || _vm$paramContext$comp === void 0 ? void 0 : _vm$paramContext$comp.find(meta => getRelatedPropsOfBinding(meta).some(propId => propId === vm.schema.id));
    const currentBindings = (_vm$paramContext$comp2 = vm.paramContext.comp) === null || _vm$paramContext$comp2 === void 0 ? void 0 : _vm$paramContext$comp2.bindings;
    return !!(bindingMeta && currentBindings && bindingMeta.id in currentBindings);
  } catch (e) {}
};
export const BindingInputMode = {
  id: 'binding',
  component: BindingEdit,
  name: '绑定',
  onExitMode: async (vm, comp) => {
    // 解除绑定
    if (hasBinding(vm)) {
      await vm.designer.setBinding(vm.paramContext.compPath, comp.bindingMeta.id, '');
    }
    return true;
  },
  onReset: async (vm, comp) => {
    // 重置绑定相当于清空绑定
    if (hasBinding(vm)) {
      await vm.designer.setBinding(vm.paramContext.compPath, comp.bindingMeta.id, '');
    }
    return true;
  },
  canEnable: vm => {
    var _vm$paramContext$comp3;
    const bindingMeta = (_vm$paramContext$comp3 = vm.paramContext.compMeta) === null || _vm$paramContext$comp3 === void 0 || (_vm$paramContext$comp3 = _vm$paramContext$comp3.bindings) === null || _vm$paramContext$comp3 === void 0 ? void 0 : _vm$paramContext$comp3.find(meta => getRelatedPropsOfBinding(meta).some(propId => propId === vm.schema.id));
    return !!bindingMeta;
  },
  getDefaultOrder: vm => hasBinding(vm) ? Infinity : -1
};
export const JsInputMode = {
  id: 'jsExpr',
  component: JsExpr,
  name: 'JS代码',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  icon: h => h("i", {
    "style": 'color:#7f0020;',
    "class": "fa fa-cogs",
    "attrs": {
      "aria-hidden": "true"
    }
  }),
  canEnable: vm => {
    if (vm.schema['uc:allowExpr'] === false) {
      return false;
    }
    return true;
  },
  onExitMode: async vm => {
    if (isExprObject(vm.editValue)) {
      // 如果当前已经是 expr模式，就重置为 prop 默认值
      try {
        vm.editValue = JSON.parse(vm.editValue.$expr);
      } catch (err) {
        vm.reset();
      }
      vm.showInputComponent = false;
    }
    return true;
  },
  onUseMode: async vm => {
    vm.showInputComponent = false;
    await vm.$nextTick();
    if (!isExprObject(vm.editValue)) {
      // 否则以当前的值 JSON stringify 一下，然后变成 expr
      vm.editValue = {
        $expr: JSON.stringify(vm.editValue, null, 2)
      };
    } else {}
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  modeHint: (h, vm) => h("div", {
    "slot": "title"
  }, [h("p", ["\u4F7F\u7528 JS \u8868\u8FBE\u5F0F \u52A8\u6001\u51B3\u5B9A\u5C5E\u6027\u7684\u503C"]), h("ul", [h("li", ["\u53EF\u4EE5\u76F4\u63A5\u5F15\u7528 \u201C\u6570\u636E\u6E90\u201D \u9762\u677F\u91CC\u7684\u53D8\u91CF"]), h("li", ["\u5F15\u7528\u53D8\u91CF\u65F6\uFF0C\u65E0\u9700\u3001\u4E5F\u4E0D\u652F\u6301 \u53CC\u82B1\u62EC\u53F7"])]), h("div", {
    "style": "color: #FF0"
  }, ["\u8FD9\u662F\u4E2A\u9AD8\u7EA7\u529F\u80FD\uFF0C\u82E5\u4E0D\u7406\u89E3\u8BF7\u52FF\u4F7F\u7528"])]),
  getDefaultOrder: vm => isExprObject(vm.rawValue) ? 1e2 : -1
};
export const InteropableInputMode = {
  id: 'interopableInput',
  component: InteropableInput,
  name: '插值表达式',
  canEnable: vm => vm.schema.type !== 'boolean'
};
export const DefaultInputMode = {
  id: 'dataFormField',
  component: undefined,
  name: '默认',
  canEnable: vm => vm.schema.type !== 'boolean'
};
export const BooleanInputMode = {
  id: 'boolInput',
  component: undefined,
  name: '默认',
  place: 'title',
  canEnable: vm => vm.schema.type === 'boolean'
};
// eslint-disable-next-line @typescript-eslint/naming-convention
export const EventPanelModes = [JsInputMode, DefaultInputMode, BooleanInputMode];
//# sourceMappingURL=ParamInputMode.js.map
